import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "pcmenubar-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("Card", {
    attrs: {
      title: _vm.$t("form.setting")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.status")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.status,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "status", $$v);
      },
      expression: "value.status"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.bgColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "bgColor", $$v);
      },
      expression: "value.bgColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.textColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "textColor", $$v);
      },
      expression: "value.textColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconHoverColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.hoverTextColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "hoverTextColor", $$v);
      },
      expression: "value.hoverTextColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textSize"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 20,
      suffix: "px"
    },
    model: {
      value: _vm.value.fontSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "fontSize", $$v);
      },
      expression: "value.fontSize"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.menuCategor")
    }
  }, [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.toggle")
    }
  }, [_c("a-switch", {
    attrs: {
      "checked-children": _vm.$t("form.visible"),
      "un-checked-children": _vm.$t("form.hidden")
    },
    model: {
      value: _vm.value.categoryStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "categoryStatus", $$v);
      },
      expression: "value.categoryStatus"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.showTitle"),
      layout: "vertical"
    }
  }, [_c("Title", {
    staticClass: "categoryTitle",
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.value.categoryTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "categoryTitle", $$v);
      },
      expression: "value.categoryTitle"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.bgColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.categoryBg,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "categoryBg", $$v);
      },
      expression: "value.categoryBg"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.categoryTextColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "categoryTextColor", $$v);
      },
      expression: "value.categoryTextColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.textOrIconHoverColor")
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.categoryTextHoverColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "categoryTextHoverColor", $$v);
      },
      expression: "value.categoryTextHoverColor"
    }
  })], 1)], 1), _c("Card", {
    attrs: {
      title: _vm.$t("form.menulist")
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("a-alert", {
    attrs: {
      message: _vm.$t("com.dragSort"),
      "show-icon": ""
    }
  })], 1), _c("a-row", [_c("a-row", [_c("draggable", {
    staticClass: "dragArea",
    attrs: {
      tag: "div",
      list: _vm.value.titles
    }
  }, _vm._l(_vm.value.titles, function (item, i) {
    return _c("a-row", {
      key: i,
      staticStyle: {
        "margin-bottom": "24px",
        cursor: "pointer"
      }
    }, [_c("a-input", {
      attrs: {
        disabled: ""
      },
      model: {
        value: item.title[_vm.defaultLangId],
        callback: function callback($$v) {
          _vm.$set(item.title, _vm.defaultLangId, $$v);
        },
        expression: "item.title[defaultLangId]"
      }
    }, [_c("a-icon", {
      attrs: {
        slot: "addonAfter",
        type: "edit"
      },
      on: {
        click: function click($event) {
          return _vm.handleListItemClick(i);
        }
      },
      slot: "addonAfter"
    })], 1)], 1);
  }), 1)], 1), _c("a-row", {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleAddItem
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("form.addMenu")) + " ")], 1)], 1)], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("form.menuSpacing"),
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.titleSpace,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "titleSpace", $$v);
      },
      expression: "value.titleSpace"
    }
  })], 1)], 1)], 1), _vm.value.titles[_vm.curMenuItem] ? _c("FormEditPage", {
    attrs: {
      show: _vm.showSlide,
      title: _vm.$t("form.menuItem")
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showSlide = $event;
      }
    }
  }, [_c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("Title", {
    attrs: {
      type: "input",
      default: _vm.$t("form.customMenu")
    },
    model: {
      value: _vm.value.titles[_vm.curMenuItem].title,
      callback: function callback($$v) {
        _vm.$set(_vm.value.titles[_vm.curMenuItem], "title", $$v);
      },
      expression: "value.titles[curMenuItem].title"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: _vm.$t("com.link"),
      layout: "vertical"
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: "5"
    },
    model: {
      value: _vm.value.titles[_vm.curMenuItem].link,
      callback: function callback($$v) {
        _vm.$set(_vm.value.titles[_vm.curMenuItem], "link", $$v);
      },
      expression: "value.titles[curMenuItem].link"
    }
  })], 1), _c("a-row", [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleDeleteItem
    }
  }, [_vm._v(_vm._s(_vm.$t("form.deleteContent")))])], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };